;(function(w){
	function FormularioInput(input){
		var self = this;
		
		var es_tipo = '';
		
		var pais = false;

		var required = true;

		var active = true;
		//console.log(input);	

		//$(input).bind('focusout', onFocusOut);
		$(input).bind('paste', onPaste);

		this.isActive = function(){
			return active;
		}
                
		this.removeClass = function (className){
			$(input).removeClass(className);
		}
		
		this.addClass = function (className){
			$(input).addClass(className);
		}

		this.setError = function(valor){
			if(typeof input!='undefined' && typeof input.type!='undefined' && input.type=='radio'){
				var radioGroup = document.getElementsByName(input.name);
				for (var i = 0; i < radioGroup.length; i++) {
					if(valor){
						$(radioGroup[i]).addClass('error');
					}else{
						$(radioGroup[i]).removeClass('error');
					}
				}	
			}else{
				if(valor){
					$(input).addClass('error');
				}else{
					$(input).removeClass('error');
				}
			}
		}

		this.setTelefono = function(){
			$(input).mask('(999) 999-9999');
			$(input).val('');// Fix IE9
			es_tipo='telefono';
		}
		
		this.setFecha = function(){
			$(input).mask('99/99/9999');
			$(input).val('');// Fix IE9
			es_tipo='fecha';
		}
		
		this.setNPI = function(){
			$(input).mask('9999999999');
			$(input).val('');// Fix IE9
			es_tipo='npi';
		}

		this.setEmail = function(){
			es_tipo='email';
		}

		this.setName = function(name){
			$(input).attr('name', name);
		}
		this.setNumerico = function(){
			$(input).on('input', function(e) {
				$(input).val($(input).val().replace(/[^0-9]/g, ''));
			});
		}
                
		this.setMaxLengthForExpr = function(expr){
			var max_length = [];
			if (expr === undefined){
				return;
			}
			expr.split('|').map(function (e){
				var rr = new RegExp('\{(.*?)\}', 'g').exec(e);
				if(rr !== null){
				return rr[1].split(',').map(function (l){
					max_length.push(parseInt(l));
				});
				}
			});
			var max = Math.max.apply(null, max_length);
			// Corto el valor por el maximo de caracteres permitidos
			input.value = input.value.trim().replace(/[^0-9]/g, '').substring(0, max);
			this.setMaxLength(max);
		}

		this.setMaxLength = function(max){
			input.maxLength = max;
		}
		
		this.setPais = function(country)
		{
			pais = country;
			
			if (pais && es_tipo=='telefono'){
				$(input).unmask();
				
				// TODO: Aqui podriamos aplicar alguna mascara... si tuvieramos un formato acorde
			}
		}

		this.resetear = function(){
			input.value = "";
			$(input).removeClass('error');
		}

		this.esVacio = function(){
			return self.getValor().replace(/(^\s*)|(\s*$)|[ ]/g, "").length == 0;
		}

		this.esMailValido = function(){
			return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(self.getValor());
		}

		this.esFechaValida = function(fecha) {
			var patron = /^\d{2}\/\d{2}\/\d{4}$/;
			
			if (!patron.test(fecha)) {
			  return false;
			}
			
			var partes = fecha.split('/');
			var dia = parseInt(partes[0], 10);
			var mes = parseInt(partes[1], 10) - 1; // Los meses en JavaScript van de 0 a 11
			var anio = parseInt(partes[2], 10);
			
			var fechaObj = new Date(anio, mes, dia);
			
			return (
			  fechaObj.getDate() === dia &&
			  fechaObj.getMonth() === mes &&
			  fechaObj.getFullYear() === anio
			);
		}

		this.esRequerido = function(requerido){
			required=requerido;
		}
	
		this.esCorrecto = function(){
			if(es_tipo=='email' && ( (!required && self.getValor()!='' && !self.esMailValido()) || (required && !self.esMailValido())) ){
				return false;
			/*}else if(es_tipo=='telefono' && self.getValor().length < 10){
				return false;
			}*/
			}else if (es_tipo=='fecha'){
				return self.esFechaValida(self.getValor());
			}else if (es_tipo=='npi'){
				return self.getValor().length==10;
			}else if(required){
				return !self.esVacio();
			}
			return true;
		}

		this.esTelefonoValido = function(){
			if (pais){
				return validarTelefonoLATAM(pais);
			}
			
			var arr_prefijos = ['201','202','203','205','206','207','208','209','210','212','213','214','215','216','217','218','219','225','228','229','231','234','239','240','248','251','252','253','254','256','260','262','267','269','270','276','281','301','302','303','304','305','307','308','309','310','312','313','314','315','316','317','318','319','320','321','323','325','330','334','336','337','339','347','351','352','360','361','385','386','401','402','404','405','406','407','408','409','410','412','413','414','415','417','419','423','425','430','432','434','435','440','443','469','470','478','479','480','484','501','502','503','504','505','507','508','509','510','512','513','515','516','517','518','520','530','540','551','559','561','562','563','567','570','571','573','574','580','585','586','601','602','603','605','606','607','608','609','610','612','614','615','616','617','618','619','620','623','626','630','631','636','641','646','650','651','660','661','662','678','682','702','703','704','706','707','708','712','713','714','715','716','717','718','719','720','724','727','731','732','734','740','754','757','760','763','765','770','772','773','774','775','781','785','786','787','801','802','803','804','805','808','810','812','813','814','815','816','817','818','828','830','831','832','843','845','847','848','850','856','857','858','859','860','862','863','864','865','870','878','901','903','904','906','907','908','909','910','912','913','914','915','916','917','918','919','920','925','928','931','936','937','939','940','941','947','949','952','954','956','970','971','972','973','978','979','980','985','989'];
			
			var arr_patrones = ['1234','2345','3456','4567','5678','6789','1111','2222','3333','4444','5555','6666','7777','8888','9999']

			var telefono = self.getValor().replace(/\D/g,'');
			if (telefono.length < 10){
				return false;
			}
						
			if(arr_prefijos.indexOf(telefono.substring(0,3)) == -1){
				return false;
			}else{
				for(var i=0; i < arr_patrones.length; i++){
					if(telefono.indexOf(arr_patrones[i]) !== -1){
						return false;
						break;
					}
				}

				return true;
			}
		}

		this.getInput = function(){
			return input;
		}

		this.getValor = function(){
			if(es_tipo=='telefono'){
				return input.value.trim();//$(input).data($.mask.dataName)();
			}else if(typeof input.type!='undefined' && input.type=='radio'){
				var radioGroup = document.getElementsByName(input.name);
				var valorSeleccionado = '';
				
				for (var i = 0; i < radioGroup.length; i++) {
					if (radioGroup[i].checked) {
						valorSeleccionado = radioGroup[i].value;
						break;
					}
				}
				return valorSeleccionado;
			}else if(typeof input.type!='undefined' && input.type=='checkbox'){
				if(input.checked){
					return input.value;
				}
			}else{
				return input.value.trim();
			}

			return '';
		}
			
		this.getAttr = function(name){
			return input.getAttribute(name);
		}

		function onFocusOut(e){
			if(self.esVacio() || (es_tipo=='telefono' && self.getValor().length < 10)){
				$(input).removeClass('full');
			}else{
				$(input).addClass('full');
			}
		}

		function onPaste(e){
			if(es_tipo=='telefono'){
				$(input).val('');
			}
		}
		
		function validarTelefonoLATAM(country)
		{
			// Esta funcion nunca deberian llamrse si no tenemos pais
			if (!country){
				return false;
			}
			
			var telefono = self.getValor().replace(/\D/g,'');
			if (telefono.length === 0)
			{ 
				return false;
			}
                        
			if(!country.nregexp){
				return true;
			}
			var re = new RegExp(country.nregexp, 'g');
			if(re.exec(telefono.replace(/^0+/, '')) === null){
				return false;
			}
			return true;
		}

	}

	w.FormularioInput = FormularioInput;

})(window)

